import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { NewPlanDefault_EditPage_Query } from "./query";

type Props = {
	hotelID: string;
	planID: string | undefined;
};

export const usePlanEditQuery = ({ hotelID, planID }: Props) => {
	const { data } = useCustomSuspenseQuery(NewPlanDefault_EditPage_Query, {
		variables: { hotelID, duplicatePlanId: planID },
		fetchPolicy: "no-cache",
	});

	return data;
};
